/* eslint-disable */

import Swiper from 'swiper'
import { api } from "../request/req.js"
import { mapState, mapMutations, mapGetters } from 'vuex'
import {newsList} from '../request/text.js'
import Head from './Head.vue';
import Foot from './Foot.vue';


export default {
    name: 'Home',
    components: {
        Swiper,
        Head,Foot
    },
    created() {
        console.log('------------------初始化阶段------------------')
        console.error('-----ppp', this.$route.params)
        this.roleInfo.forEach(item => {
            let imgName = this.toLowerName(item.img)
            let content = this.toLowerName(item.introduce)
            let header = this.toLowerName(item.icon)
            let isheader = this.toLowerName(item.isIcon)
            item.img = require(`@/assets/vi/index/part3/${imgName}.png`)
            item.introduce = require(`@/assets/vi/index/part3/${content}.png`)
            item.icon = require(`@/assets/vi/index/part3/${header}.png`)
            item.isIcon = require(`@/assets/vi/index/part3/${isheader}.png`)
          });
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        roleSelect() {
            return this.roleInfo[this.roleItem]
          },
          newsType() {
            return this.newsInfo.type === 1 ? '[NEWS]' : '[EVENT]'
          },
        ...mapState(['userInfo'])
    },
    data() {
        return {
            
      roleItem: 0,
      roleChange: false,
      mobile:null,
      otherGroup: [
        { name: 'Facebook', type: 'fb', event: 'FB_Page' },
        { name: 'Twitter', type: 'tt', event: 'TW_Page' },
        { name: 'Discord', type: 'dc', event: 'DC_group' },
        { name: 'YouTube', type: 'yt', event: 'YT_page' }
      ],
      roleInfo: [
        {
          id: 0,
          introduce: "introduce0",
          icon: "icon0",
          isIcon: "isIcon0",
          img: "pic0",
          show: true,
        },
        {
          id: 1,
          introduce: "introduce1",
          icon: "icon1",
          isIcon: "isIcon1",
          img: "pic1",
        },
        {
          id: 2,
          introduce: "introduce2",
          icon: "icon2",
          isIcon: "isIcon2",
          img: "pic2",
        },
        {
          id: 3,
          introduce: "introduce3",
          icon: "icon3",
          isIcon: "isIcon3",
          img: "pic3",
        },
        {
          id: 4,
          introduce: "introduce4",
          icon: "icon4",
          isIcon: "isIcon4",
          img: "pic4",
        },
      ],
      newsInfo: {}
        }
    },
    mounted() {
        // this.getSectionPosition()
        this.createdSwiper()
        // this.getNews()
        // this.mobile = isMobile()
    },
    methods: {
        ...mapMutations(['logout']),
        toStore(url) {
            location.href = url
        },
        toPage(page) {
            let pageName = page.toLocaleLowerCase()
            return urlPath(pageName)
          },
        roleChangeHandle(index) {
            if (this.roleItem === index) return;
            this.roleChange = true
            setTimeout(() => {
              this.roleItem = index
              this.roleChange = false
            }, 200);
          },
          toLowerName(str) {
            return str.toLocaleLowerCase().replace(/\s/, '');
          },
          toTop() {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          },
        createdSwiper() {
            new Swiper('.swiper', {
              autoplay: false,
              // autoplay: {
              //   delay: 3000,
              //   disableOnInteraction: false,
              // },
              navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
              },
              loop: true,
              effect: "coverflow",
              slidesPerView: 1.5,
              centeredSlides: true,
              coverflowEffect: {
                rotate: 0,
                stretch: "49.5%",
                depth: 400,
                modifier: 1,
                slideShadows: true,
              },
              spaceBetween: "-30%",
            })
          },
    }
}